import { createRoot } from 'react-dom/client';

import 'leaflet/dist/leaflet.css'; 

// styles
import './index.scss';

// project-imports
import App from './App';
import { initSessionWatcher } from './services/sessionWatcher.js';


import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';

initSessionWatcher();

const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(<App />);
